class SprintCarousel extends HTMLElement {
  connectedCallback() {
    this.scroller = this.querySelector('[data-sprint-scroller]');
    if (!this.scroller) return;
    this.querySelectorAll('[data-sprint-prev]').forEach((button) => {
      button.addEventListener('click', () => this.move(-1));
    });
    this.querySelectorAll('[data-sprint-next]').forEach((button) => {
      button.addEventListener('click', () => this.move(1));
    });
  }

  move(direction) {
    const item = this.scroller.querySelector('[data-sprint-item]');
    const gap = parseFloat(getComputedStyle(this.scroller).columnGap || 0);
    const distance = item ? item.getBoundingClientRect().width + gap : this.scroller.clientWidth * 0.8;
    this.scroller.scrollBy({ left: direction * distance, behavior: 'smooth' });
  }
}

if (!customElements.get('sprint-carousel')) {
  customElements.define('sprint-carousel', SprintCarousel);
}

class SprintPopup extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('[data-sprint-popup-dialog]');
    this.teaser = this.querySelector('[data-sprint-popup-teaser]');
    this.closeButtons = this.querySelectorAll('[data-sprint-popup-close]');
    this.storageKey = `sprint-popup-${this.dataset.popupId}`;
    this.delay = Number(this.dataset.delay || 5) * 1000;
    this.frequency = Number(this.dataset.frequency || 7);

    this.closeButtons.forEach((button) => button.addEventListener('click', () => this.close()));
    this.teaser?.addEventListener('click', () => this.open(true));
    this.addEventListener('click', (event) => {
      if (event.target === this) this.close();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.hasAttribute('open')) this.close();
    });

    const forcedOpen = this.dataset.forceOpen === 'true';
    if (forcedOpen || !this.wasRecentlyClosed()) {
      window.setTimeout(() => this.open(false), this.delay);
    } else if (this.teaser) {
      this.teaser.hidden = false;
    }
  }

  wasRecentlyClosed() {
    try {
      const value = Number(localStorage.getItem(this.storageKey));
      if (!value) return false;
      return Date.now() - value < this.frequency * 86400000;
    } catch (error) {
      return false;
    }
  }

  open(fromTeaser) {
    this.setAttribute('open', '');
    this.teaser && (this.teaser.hidden = true);
    document.documentElement.classList.add('sprint-popup-open');
    window.setTimeout(() => this.dialog?.focus(), 50);
    if (fromTeaser) this.removeAttribute('aria-hidden');
  }

  close() {
    this.removeAttribute('open');
    document.documentElement.classList.remove('sprint-popup-open');
    if (this.teaser) this.teaser.hidden = false;
    try { localStorage.setItem(this.storageKey, String(Date.now())); } catch (error) {}
  }
}

if (!customElements.get('sprint-popup')) {
  customElements.define('sprint-popup', SprintPopup);
}

class SprintCopyCode extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    this.button?.addEventListener('click', async () => {
      const code = this.dataset.code;
      if (!code) return;
      try {
        await navigator.clipboard.writeText(code);
        const original = this.button.textContent;
        this.button.textContent = this.dataset.success || 'Copiado!';
        window.setTimeout(() => { this.button.textContent = original; }, 1800);
      } catch (error) {}
    });
  }
}

if (!customElements.get('sprint-copy-code')) {
  customElements.define('sprint-copy-code', SprintCopyCode);
}
